import { render, staticRenderFns } from "./PhieuThayDoiThongTin.vue?vue&type=template&id=78736415&scoped=true&"
import script from "./PhieuThayDoiThongTin.vue?vue&type=script&lang=js&"
export * from "./PhieuThayDoiThongTin.vue?vue&type=script&lang=js&"
import style0 from "./PhieuThayDoiThongTin.vue?vue&type=style&index=0&id=78736415&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78736415",
  null
  
)

export default component.exports